<div class="cbi-container">
  <div *ngIf="!!formula" class="cgi-image" [class.selected]="formula.selected" [attr.style]="tileBgStyle()"
       (pointerdown)="mouseDown()" (pointerup)="mouseUp()">&nbsp;
    <div class="cgi-title">{{formula.title}}</div>
    <div class="selected-check"><ion-checkbox [checked]="formula.selected" (click)="toggleSelected()"></ion-checkbox></div>
  </div>
</div>
